module.exports = __webpack_public_path__ + "static/media/boy.8e6aefe1.jpg";